// import { openWebview } from '@docs/common'
import { triggerLink } from 'common/util'
import styles from './index.module.scss'

interface ActionSheetProps {
  track: (title: string) => void
  close: () => void
  visible: boolean
  actions: Array<{ url: string, title: string, id: number }>
}

export default function ActionSheet({
  actions,
  close,
  visible,
  track
}: ActionSheetProps) {

  const jumpToOpenWebview = (item: { url: string, title: string, id: number }) => {
    track && track(item.title || '')
    close()
    setTimeout(() => {
      triggerLink(item.url || '')
    }, 300);
  }

  return (
    <div className={styles.sheet} style={{ display: visible ? undefined : 'none' }}>
      <div className={styles.mask} onClick={close}></div>
      <div className={styles.body}>
        <div className={styles.actions}>
          {actions.map(item => (
            item.url ? <div className={styles.button} onClick={() => jumpToOpenWebview(item)} key={item.id}>{item.title}</div> : null
          ))}
        </div>
        <div className={styles.footer}>
          <div className={styles.button} onClick={close}>Cancle</div>
        </div>
      </div>
    </div>
  )
}
